import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { HomeFacade } from '../../../../../Facades/home.facade';

@Component({
  selector: 'app-home-pulse',
  standalone: true,
  imports: [COMMON_IMPORTS],
  templateUrl: './home-pulse.component.html',
  styleUrl: './home-pulse.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePulseComponent {
  readonly home = inject(HomeFacade);

  readonly hasOsShares = computed(() => this.home.osShares().length > 0);

  readonly isStepListVisible = computed(
    () => this.home.isFleetScanning() || this.home.hasFleetFailure()
  );

  readonly isEmptyStateVisible = computed(
    () =>
      !this.home.hasPulseData() &&
      !this.hasOsShares() &&
      !this.home.isFleetScanPending() &&
      !this.isStepListVisible()
  );

  toPercent(ratio: number | null): number {
    return ratio === null ? 0 : Math.round(ratio * 100);
  }

  levelOf(ratio: number | null): string {
    const percent = this.toPercent(ratio);
    if (percent >= 90) return 'high';
    if (percent >= 70) return 'mid';
    return 'low';
  }

  onScan(): void {
    this.home.startFleetScan();
  }

  onRescan(): void {
    this.home.rescanFleet();
  }
}
